/*
 * Announcement bar countdown timer.
 * Counts down to a wall-clock date and time in a named time zone (Central European
 * time for this store) and hides the block, or the whole bar, once the time has passed.
 */
(function () {
  if (window.announcementCountdownLoaded) return;
  window.announcementCountdownLoaded = true;

  var SELECTOR = '[data-countdown]';
  var DATE_PATTERN = /^(\d{4})-(\d{1,2})-(\d{1,2})$/;
  var TIME_PATTERN = /^(\d{1,2}):(\d{2})$/;
  var formatters = {};

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function getFormatter(timeZone) {
    if (!formatters[timeZone]) {
      formatters[timeZone] = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        hourCycle: 'h23',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    }
    return formatters[timeZone];
  }

  // Milliseconds the zone's wall clock is ahead of UTC at the given instant.
  function zoneOffset(timestamp, timeZone) {
    var parts = {};
    getFormatter(timeZone).formatToParts(new Date(timestamp)).forEach(function (part) {
      parts[part.type] = part.value;
    });
    var wallClock = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute, +parts.second);
    return wallClock - Math.floor(timestamp / 1000) * 1000;
  }

  // Converts a wall-clock time in the given zone to a UTC timestamp.
  function zonedTimeToUtc(year, month, day, hour, minute, timeZone) {
    var wallClock = Date.UTC(year, month - 1, day, hour, minute);
    var utc = wallClock - zoneOffset(wallClock, timeZone);
    var corrected = wallClock - zoneOffset(utc, timeZone);
    return corrected;
  }

  function getTarget(el) {
    if (el.dataset.countdownTarget !== undefined) {
      return el.dataset.countdownTarget === '' ? null : Number(el.dataset.countdownTarget);
    }

    var target = null;
    var date = DATE_PATTERN.exec(el.getAttribute('data-countdown-date') || '');
    var time = TIME_PATTERN.exec(el.getAttribute('data-countdown-time') || '');
    var timeZone = el.getAttribute('data-countdown-timezone') || 'Europe/Paris';

    if (date && time) {
      var value = zonedTimeToUtc(+date[1], +date[2], +date[3], +time[1], +time[2], timeZone);
      if (!isNaN(value)) target = value;
    }

    el.dataset.countdownTarget = target === null ? '' : String(target);
    return target;
  }

  function formatRemaining(ms) {
    var total = Math.floor(ms / 1000);
    var days = Math.floor(total / 86400);
    var hours = Math.floor((total % 86400) / 3600);
    var minutes = Math.floor((total % 3600) / 60);
    var seconds = total % 60;
    var text = pad(hours) + 'h ' + pad(minutes) + 'm ' + pad(seconds) + 's';
    return days > 0 ? days + 'd ' + text : text;
  }

  function expire(el) {
    if (el.classList.contains('is-expired')) return;
    el.classList.add('is-expired');

    var slide = el.closest('[data-slide]');
    var wrapper = el.closest('[data-announcement-wrapper]');
    if (slide) slide.hidden = true;

    if (wrapper) {
      var slides = wrapper.querySelectorAll('[data-slide]');
      var allHidden = Array.prototype.every.call(slides, function (item) { return item.hidden; });
      if (allHidden) wrapper.hidden = true;
    }

    document.dispatchEvent(new CustomEvent('theme:resize', { bubbles: true }));
  }

  function render(el, now) {
    var target = getTarget(el);
    var remaining = target === null ? 0 : target - now;

    if (remaining <= 0) {
      expire(el);
      return;
    }

    var timer = el.querySelector('[data-countdown-timer]');
    if (!timer) return;

    var text = formatRemaining(remaining);
    if (timer.textContent !== text) timer.textContent = text;
    el.classList.add('is-ready');
  }

  function update() {
    var now = Date.now();
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      render(el, now);
    });
  }

  function schedule() {
    setTimeout(function () {
      update();
      schedule();
    }, 1000 - (Date.now() % 1000));
  }

  update();
  schedule();
  document.addEventListener('shopify:section:load', update);
})();
